import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserProfile } from '../../_models/user-profile';
import { Field } from '../../_models/field';
import { UserProfileService } from '../../_services/user-profile.service';
import { Params, Router, ActivatedRoute } from '@angular/router';
import { PreferencesService } from '../_services/preferences.service';
import { PortalApiService } from '../../_services/portal-api.service';
import { FieldFilters } from '../../_models/preferences';
import { FieldFilterService } from '../_services/field-filter.service';

@Component({
  selector: 'app-data-entry',
  templateUrl: './data-entry.component.html',
  styleUrls: ['./data-entry.component.css']
})
export class DataEntryComponent implements OnInit, OnDestroy {
  userProfile: UserProfile;
  fieldQuery: string;
  fieldView: string = 'all';
  listDisplay: boolean = false;
  errorGetFields: boolean = false;
  errorGetFieldsMessage: string;
  isLoading: boolean = false;
  isLoadingAllFields: boolean = false;
  userFields: Field[] = [];
  receivedFields: Field[] = [];
  filters: FieldFilters = new FieldFilters;
  isBulkEdit: boolean = false;

  // Subjects
  private onDestroy$ = new Subject<void>();

  constructor(
    private userService: UserProfileService,
    private router: Router,
    private route: ActivatedRoute,
    private preferencesService: PreferencesService,
    private apiService: PortalApiService,
    private fieldFilterService: FieldFilterService
  ) {
    this.userService.userProfile$.pipe(takeUntil(this.onDestroy$)).subscribe(
      userProfile => {
        this.userProfile = userProfile;
        this.preferencesService.listDisplay$.pipe(takeUntil(this.onDestroy$)).subscribe(listDisplay => { this.listDisplay = listDisplay });
      });
  }

  ngOnInit(): void {
    this.getFields();
    this.filters = this.fieldFilterService.resetFilters();

    const queryParams = this.route.snapshot.queryParams;
    Object.keys(queryParams).forEach(param => {
      switch (param) {
        case 'view':
          this.fieldView = queryParams[param];
          break;
        case 'query':
          this.filters.fieldQuery = queryParams[param];
          break;
        default:
          break;
      }
    });

    this.isBulkEdit = this.router.url.includes('bulkedit');
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  changeFieldView(viewName: string) {
    this.fieldView = viewName;
    this.updateQueryParms('view', viewName);
  }

  updateQueryParms(paramName: string, paramValue: any) {
    const updatedParam: Params = {};
    updatedParam[paramName] = paramValue;
    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: updatedParam,
        queryParamsHandling: 'merge'
      }
    );
  }

  swapViews(displayListStyle: boolean) {
    this.listDisplay = displayListStyle;
    this.preferencesService.updateCardDisplay(this.listDisplay);
  }

  updateFilters(param: string, newValue: any) {
    this.updateQueryParms(param, newValue);
  }

  getFields() {
    this.errorGetFields = false;
    this.isLoading = true;

    if (this.userProfile.id) {
      this.apiService.getFields().subscribe({
        next: (data: Field[]) => {
          console.log(data);
          this.isLoading = false;
          this.receivedFields = data;

          for (let i = 0; i < data.length; i++) {
            if (data[i].isFavorite) {
              this.userFields.push(data[i]);
              this.changeFieldView('favorites');
            }
          }
        },
        error: err => {
          console.log(err)
          this.errorGetFields = true;
          this.errorGetFieldsMessage = (err.error || 'An error occurred. Failed to retrieve fields.');
          this.isLoading = false;
        }
      });
    }   
  }

  updateUserFieldsHandler(field: Field) {
    let receivedFieldsIndex: number = this.receivedFields.findIndex((obj: Field) => {
      return obj.fieldID == field.fieldID;
    });

    if (field.isFavorite) {
       /* Remove field from Favorites */ 
      let userFieldsIndex: number = this.userFields.findIndex((obj: Field) => {
        return obj.fieldID == field.fieldID;
      });
      this.userFields.splice(userFieldsIndex, 1);
      field.isFavorite = false;
      //this.notFollowingFields.sort(this.listHelper.sortPropertyDate('lastUpdateTime', true));
      this.receivedFields[receivedFieldsIndex].isFavorite = false;
    } else {
       /* Add field to Favorties */ 
      field.isFavorite = true;
      this.userFields.push(field);
      //this.userFields.sort(this.listHelper.sortPropertyDate('lastUpdateTime', true));
      this.receivedFields[receivedFieldsIndex].isFavorite = true;
    }
  }
}
